
import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const OlivianGalleryPage = lazy(() => import("../pages/gallery-olivian/page"));
const HoneybeeGalleryPage = lazy(() => import("../pages/gallery-honeybee/page"));
const DoorCountyGalleryPage = lazy(() => import("../pages/gallery-door-county/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/gallery/the-olivian-on-4th",
    element: <OlivianGalleryPage />,
  },
  {
    path: "/gallery/the-honey-bee",
    element: <HoneybeeGalleryPage />,
  },
  {
    path: "/gallery/door-county",
    element: <DoorCountyGalleryPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
